export default __webpack_public_path__ + "static/media/pasadalogo-sidebar.07427a7b.png";